(function () {
    'use strict';

    'use strict';
angular.module('ng-komondor-media-library', ['ngKomondorMediaLibrary']);
// Leave typo for backward compatibility
angular.module('ng-komondor-media-libary', ['ngKomondorMediaLibrary']);
angular.module('komondor-media', ['ngKomondorMediaLibrary']);
angular.module('ngKomondorMediaLibrary', ['js-data', 'angularFileUpload', 'ngCookies', 'ui.bootstrap', 'ng-komondor-resource-view', 'ngKomondorAccess', 'ng-komondor-media-library.templates']).factory('targetedImageryConfig', function TargetedImageryConfig() {
    var config = {
        allowEdit: false,
        allowMake: false,
        types: { logo: 'Client Logo' }
    };
    return config;
}).factory('mediaLibraryTaggingConfig', function MediaLibraryTaggingConfig() {
    var config = { allowEdit: false };
    return config;
}).factory('mediaLibraryUploadConfig', function mediaLibraryUploadConfig() {
    var config = { queueLimit: Number.MAX_VALUE };
    return config;
}).factory('itemsSelected', function itemsSelected() {
    return {
        numOfItemsSelected: 0,
        setNumOfItemsSelected: function setNumOfItemsSelected(itemsCount) {
            this.numOfItemsSelected = itemsCount;
        },
        getNumOfItemsSelected: function getNumOfItemsSelected() {
            return this.numOfItemsSelected;
        }
    };
});
'use strict';
angular.module('ngKomondorTargetedImagery', ['js-data', 'ui.bootstrap']).config(["$provide", function ($provide) {
    $provide.decorator('mediaViewOptions', ["$delegate", "targetedImageryAction", function ($delegate, targetedImageryAction) {
        $delegate.actions.push(targetedImageryAction);
        return $delegate;
    }]);
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').run(["Asset", function (Asset) {
}])    // jshint ignore:line
.factory('Asset', ["DS", "$state", function (DS, $state) {
    return DS.defineResource({
        name: 'Asset',
        endpoint: 'assets',
        defaultValues: {
            action_id: 0,
            folder_id: 0
        },
        methods: {
            goInto: function goInto() {
                if (this.type === 'folder') {
                    $state.go('admin.media', {
                        folder_id: this.id,
                        offset: null,
                        name: null
                    });
                } else {
                    $state.go('admin.media.preview', { id: this.id });
                }
            },
            isSvg: function isSvg() {
                return this.format && this.format.length && this.format.includes('svg');
            }    // relations: {
                 //     hasMany: {
                 //         File: {
                 //             foreignKey: 'asset_id',
                 //             localField: 'files',
                 //         },
                 //     },
                 //     hasOne: {
                 //         Asset: {
                 //             localField: 'parent',
                 //             foreignKey: 'folder_id',
                 //         },
                 //     },
                 // },
        }
    });
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').factory('assetCache', ["$q", "$timeout", "Asset", function ($q, $timeout, Asset) {
    return {
        get: function get(assetId, options) {
            options = typeof options !== 'undefined' ? options : { bypassCache: false };
            return Asset.find(assetId, options).then(function () {
                return Asset.get(assetId);
            });
        }
    };
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').run(["File", function (File) {
}])    // jshint ignore:line
.factory('File', ["DS", function (DS) {
    return DS.defineResource({
        name: 'File',
        endpoint: 'files'
    });
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').provider('kdMedia', function () {
    var options = { enableVideoPoster: true };
    /**
     * @deprecated
     */
    this.addMimeType = function () {
    };
    this.config = function (name, value) {
        if (!options[name]) {
            throw new Error('ng-komondor-media-library: config not available!');
        }
        options[name] = value;
    };
    this.$get = function () {
        return { enableVideoPoster: options.enableVideoPoster };
    };
});
'use strict';
angular.module('ngKomondorMediaLibrary').config(["resourceStateProvider", "modalStateProvider", function (resourceStateProvider, modalStateProvider) {
    resourceStateProvider.state('admin.media', {
        title: 'Media library',
        url: 'media',
        model: 'Asset',
        viewOptions: 'mediaViewOptions',
        query: ['folder_id'],
        params: { folder_id: '0' },
        edit: {
            controller: 'MediaEditCtrl',
            templateUrl: 'ng-komondor-media-library/media.edit.html',
            resolve: {
                actions: ['Action', function (Action) {
                                    return Action.findAll();
                                }],
                files: ['File', 'modalState', function (File, modalState) {
                                    var params = { asset_id: modalState.stateParams.id };
                                    File.ejectAll(params);
                
                                    return File.findAll(params);
                                }],
                assetTypes: function assetTypes() {
                    return ['folder', 'image', 'video', 'audio'];
                }
            }
        },
        move: true
    });
    modalStateProvider.state('admin.media.preview', {
        windowClass: 'modal-media-preview',
        url: '/preview/{id:[0-9w-]+}',
        templateUrl: 'ng-komondor-media-library/media.preview.html',
        controller: ['$scope', 'model', 'File', function ($scope, model, File) {
                    $scope.model = model;
                    File.bindAll({ asset_id: model.id }, $scope, 'files');
                }],
        resolve: {
            model: ['Asset', 'modalState', function (Asset, modalState) {
                            return Asset.find(modalState.stateParams.id);
                        }],
            files: ['File', 'modalState', function (File, modalState) {
                            var params = { asset_id: modalState.stateParams.id };
                            File.ejectAll(params);
            
                            return File.findAll(params);
                        }]
        }
    });
    modalStateProvider.state('admin.media.upload', {
        url: '/upload/{folder_id:[0-9]+}',
        controller: 'MediaUpload',
        controllerAs: '$ctrl',
        templateUrl: 'ng-komondor-media-library/media-upload.html',
        params: { folder_id: 0 },
        resolve: {
            folderId: ['modalState', function (modalState) {
                            return modalState.stateParams.folder_id;
                        }]
        }
    });
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').factory('mediaViewOptions', ["$rootScope", "$state", "$q", "extendDeep", "Asset", "resourceViewOptions", "moveAction", "listNameTemplate", "gridThumbTemplate", "gridNameTemplate", "createFolderAction", function ($rootScope, $state, $q, extendDeep, Asset, resourceViewOptions, moveAction, listNameTemplate, gridThumbTemplate, gridNameTemplate, createFolderAction) {
    var mediaOptions = angular.copy(resourceViewOptions);
    var createFolder = angular.copy(createFolderAction);
    mediaOptions.actions.push(moveAction);
    mediaOptions.sorts = [{
            label: 'Type',
            sort: 'type asc,name asc'
        }];
    mediaOptions.toolbar = [createFolder];
    mediaOptions.toolbar.push({
        name: 'upload',
        buttonClass: 'btn btn-primary',
        template: '<i class="material-icon material-icon-upload"></i> Upload',
        act: function act() {
            $state.go('.upload');
        },
        show: function show() {
            return true;
        }
    });
    //rowClassifier - allows assignment of classes to wrapping row
    //onItemClick - delegated click handler (perscribe behaviour when click on asset)
    //list - injectable html + configuration options
    //grid - injectable html
    extendDeep(mediaOptions, {
        tagging: false,
        viewIndex: 1,
        queryDefaults: { where: { folder_id: 0 } },
        rowClassifier: function rowClassifier(row, classes) {
            return classes;
        },
        onItemClick: function onItemClick($event, model) {
            $event.stopPropagation();
            model.goInto();
        },
        list: {
            columns: [{
                            label: 'Name',
                            name: 'name',
                            template: listNameTemplate('name', 'links.thumb', 'type'),
                            sortable: true
                        }, {
                            label: 'Size',
                            name: 'size',
                            template: '<span class="resource-ui-filesize">{{ model.size | bytes }}</span>',
                            sortable: false
                        }, {
                            label: 'Format',
                            template: '<span class="resource-ui-filetype">{{ model.format.join(", ") }}</span>',
                            sortable: false
                        }, {
                            label: 'Last modified',
                            name: 'updated_at',
                            template: '<span>{{ model.updated_at | date }}</span>',
                            sortable: true
                        }]
        },
        grid: {
            fields: [{
                            template: gridThumbTemplate('links.thumb', 'type')
                        }, {
                            template: gridNameTemplate('name', null)
                        }]
        }
    });
    return mediaOptions;
}]);
'use strict';
angular.module('ngKomondorMediaLibrary')    /**
 * ng-file-over class didn't get removed after dropping files, or moving out of nv-file-over region
 * issue discussed at https://github.com/nervgh/angular-file-upload/issues/231 (closed but not resolved)
 * patch by v-zabavsky
 */.config(["$provide", function ($provide) {
    $provide.decorator('nvFileOverDirective', ["$delegate", function ($delegate) {
        var directive = $delegate[0], link = directive.link;
        directive.compile = function () {
            return function (scope, element, attrs) {
                var overClass = attrs.overClass || 'nv-file-over';
                link.apply(this, arguments);
                element.on('dragleave', function () {
                    angular.element(this).removeClass(overClass);
                });
            };
        };
        return $delegate;
    }]);
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').factory('Uploader', ["FileUploader", "$cookies", function (FileUploader, $cookies) {
    return function (options) {
        return new FileUploader(angular.extend({
            url: '/api/files',
            withCredentials: true,
            headers: { 'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN') }
        }, options));
    };
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').controller('MediaUpload', ["$scope", "$window", "folderId", "Uploader", "File", "DS", "mediaLibraryUploadConfig", "itemsSelected", function ($scope, $window, folderId, Uploader, File, DS, mediaLibraryUploadConfig, itemsSelected) {
    var vm = this;
    /**
     * methods
     */
    this.onSuccessItem = function (fileItem, responseData) {
        File.inject(responseData);
        DS.emit('media-file-uploaded', responseData);
    };
    this.onAfterAddingAll = function (items) {
        if (vm.uploader.queue.length > mediaLibraryUploadConfig.queueLimit) {
            vm.uploader.queue = items.slice(0, mediaLibraryUploadConfig.queueLimit);
            itemsSelected.setNumOfItemsSelected(items.length);
        }
    };
    this.clear = function () {
        vm.uploader.clearQueue();
        itemsSelected.setNumOfItemsSelected(0);
    };
    this.close = function () {
        $scope.$close();
        vm.clear();
    };
    /**
     * scope members
     */
    this.uploader = new Uploader({
        autoUpload: true,
        onSuccessItem: this.onSuccessItem,
        onAfterAddingAll: this.onAfterAddingAll,
        formData: [{ folder_id: folderId }]
    });
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').controller('MediaEditCtrl', ["$rootScope", "$scope", "$window", "$q", "extendDeep", "Uploader", "File", "model", "Action", "notify", "folderId", "assetTypes", "targetedImageryConfig", "mediaLibraryTaggingConfig", "files", "kdMedia", function ($rootScope, $scope, $window, $q, extendDeep, Uploader, File, model, Action, notify, folderId, assetTypes, targetedImageryConfig, mediaLibraryTaggingConfig, files, kdMedia) {
    ////
    // Scope members
    $scope.kdMedia = kdMedia;
    $scope.targetedImageryConfig = targetedImageryConfig;
    $scope.mediaLibraryTaggingConfig = mediaLibraryTaggingConfig;
    $scope.uploader = new Uploader({ autoUpload: true });
    $scope.uploader.onSuccessItem = onSuccessItem;
    $scope.model = model;
    $scope.isNew = !$scope.model.id;
    $scope.assetTypes = assetTypes || ['folder', 'image', 'video', 'audio'];
    if (angular.isArray($scope.model.config) || !$scope.model.config) {
        $scope.model.config = { poster: { time: null } };
    }
    ////
    // Scope functions
    $scope.create = create;
    $scope.remove = remove;
    $scope.save = save;
    $scope.cancel = cancel;
    ////
    // js-data binded lists
    Action.bindAll({}, $scope, 'actions');
    File.bindAll({ asset_id: $scope.model.id }, $scope, 'files');
    $scope.primaryFile = null;
    var activeFiles = File.filter({
        asset_id: $scope.model.id,
        active: 1
    });
    if (activeFiles.length > 0) {
        $scope.primaryFile = activeFiles[0];
    } else {
        if (files && files.length > 0) {
            $scope.primaryFile = files[0];
        }
    }
    ////
    // Compute
    if (!$scope.model.type) {
        $scope.model.type = 'folder';
    }
    if ($scope.model.folder_id === undefined) {
        $scope.model.folder_id = folderId;
    }
    ////
    // Watches
    $scope.$watch('model.id', function () {
        $scope.uploader.formData = [{ asset_id: $scope.model.id }];
    });
    ////
    // Functions
    function create() {
        return model.DSCreate().then(function (model) {
            $scope.model = model;
        });
    }
    function remove(fileItem) {
        // for editing asset, existing files, already bind File to this item
        if (fileItem.DSDestroy) {
            fileItem.DSDestroy().then(function () {
                if (!$scope.model.areas) {
                    return;
                }
                var removed = false;
                for (var i = 0; i < $scope.model.areas.length; i++) {
                    if ($scope.model.areas[i].background === fileItem.id) {
                        $scope.model.areas.splice(i, 1);
                        removed = true;
                    }
                }
                if (removed) {
                    $scope.model.DSSave().then(function () {
                        $rootScope.$broadcast('targeted-imagery:saved', $scope.model);
                    });
                }
            });
        }    // for curr uploading/uploaded file
        else {
            fileItem.remove();
        }
    }
    function save() {
        // upsert is true by default
        return $scope.model.DSCreate().then(function () {
            $scope.$close(model);
        });
    }
    function cancel() {
        if (!$scope.isNew || !$scope.model.id) {
            $scope.$close();
            return;
        }
        // while creating new asset, 'cancel' should remove all created asset(s)
        $scope.model.DSDestroy().then($scope.$close);
    }
    /**
     * uploader event handlers
     */
    function onSuccessItem(fileItem, response) {
        File.inject(response);
        // remove from uploader.queue
        fileItem.remove();
    }
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').directive('fileExisting', function () {
    return {
        restrict: 'A',
        scope: {
            item: '=fileExisting',
            onRemove: '&'
        },
        templateUrl: 'ng-komondor-media-library/file.existing.html'
    };
});
'use strict';
angular.module('ngKomondorMediaLibrary').directive('fileUploader', ["File", "Uploader", "$window", "itemsSelected", "mediaLibraryUploadConfig", function (File, Uploader, $window, itemsSelected, mediaLibraryUploadConfig) {
    controller.$inject = ["$scope"];
    function controller($scope) {
        $scope.queueLimit = mediaLibraryUploadConfig.queueLimit;
        $scope.getTotalItems = function () {
            return itemsSelected.getNumOfItemsSelected();
        };
        $scope.isExceeded = function () {
            return itemsSelected.getNumOfItemsSelected() - $scope.queueLimit > 0;
        };
        /**
         * Events
         */
        function preventDefault(e) {
            e = e || $window.event;
            e.preventDefault();
        }
        $window.addEventListener('dragover', preventDefault, false);
        $window.addEventListener('drop', preventDefault, false);
        $scope.$on('$destroy', function () {
            $window.removeEventListener('dragover', preventDefault, false);
            $window.removeEventListener('drop', preventDefault, false);
        });
    }
    return {
        restrict: 'A',
        scope: { uploader: '=fileUploader' },
        controller: controller,
        controllerAs: '$ctrl',
        bindToController: true,
        templateUrl: 'ng-komondor-media-library/file.uploader.html'
    };
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').directive('fileUploading', function () {
    return {
        restrict: 'A',
        scope: { item: '=fileUploading' },
        templateUrl: 'ng-komondor-media-library/file.uploading.html',
        controller: ["$scope", function controller($scope) {
            $scope.getResponse = function () {
                if ($scope.item._xhr) {
                    if ($scope.item._xhr.statusText === 'Request Entity Too Large') {
                        return 'File size exceeds limit (500mb)';
                    }
                    return $scope.item._xhr.statusText;
                }
            };
        }]
    };
});
'use strict';
angular.module('ngKomondorMediaLibrary').directive('mediaDisplay', ["Asset", "assetCache", function (Asset, assetCache) {
    return {
        restrict: 'AE',
        scope: { assetId: '=' },
        templateUrl: 'ng-komondor-media-library/media.display.html',
        link: function link($scope, element) {
            element.addClass('media-display');
            $scope.model = null;
            $scope.$watch('assetId', function (assetId) {
                if (!assetId) {
                    $scope.model = null;
                    return;
                }
                assetCache.get(assetId).then(function (asset) {
                    $scope.model = asset;
                });
            });
        }
    };
}]);
'use strict';
angular.module('ngKomondorMediaLibrary')    /**
 * media-picker directive
 *
 * @param  {String} [types] - media types SELECT-ABLE in the resourcePicker. 'image' | 'video, audio'
 * @param  {String} [button-label] - text of button to trigger resourcePicker. 'Select File'(default)
 */.directive('mediaPicker', ["assetCache", "$state", "ResourcePicker", "extendDeep", "$uibModal", "kdGate", function (assetCache, $state, ResourcePicker, extendDeep, $uibModal, kdGate) {
    controller.$inject = ["$scope", "$rootScope"];
    return {
        replace: true,
        require: 'ngModel',
        scope: {
            types: '@',
            buttonLabel: '@'
        },
        link: link,
        controller: controller,
        template: '<div class="media-picker-select">\n            <button type="button" class="btn btn-default media-picker-select-btn" ng-click="openResourcePicker()">\n                {{ selectOrChange() }} {{ buttonLabel }}\n            </button>\n            <button ng-if="selectedAsset"\n                    type="button"\n                    class="btn btn-default media-picker-select-info"\n                    ng-click="preview(); $event.stopPropagation();">\n                <i class="material-icon material-icon-info-outline"></i></button>\n            <button type="button" class="btn btn-default" ng-click="clear()">Clear</button>\n        </div>'
    };
    function controller($scope, $rootScope) {
        var mediaTypeOption = void 0;
        var defaultOptions = {
            viewOptions: 'mediaViewOptions',
            model: 'Asset',
            modelNameField: 'name',
            assetTypes: [],
            enableCreate: false,
            toolbar: []
        };
        // assetTypes - the media VISIBLE for user in resource-view (diff from $scope.types)
        var mediaTypeOptions = {
            image: {
                title: 'Image picker',
                buttonLabel: 'image',
                assetTypes: ['folder', 'image']
            },
            video: {
                title: 'Video picker',
                buttonLabel: 'video',
                assetTypes: ['folder', 'video']
            },
            audio: {
                title: 'Audio picker',
                buttonLabel: 'audio',
                assetTypes: ['folder', 'audio']
            },
            document: {
                title: 'Document picker',
                buttonLabel: 'document',
                assetTypes: ['folder', 'document']
            },
            folder: {
                title: 'Folder picker',
                buttonLabel: 'folder',
                assetTypes: ['folder']
            },
            all: {
                title: 'Media picker',
                buttonLabel: 'file',
                assetTypes: ['folder', 'image', 'video', 'audio', 'document']
            }
        };
        var types = $scope.types ? $scope.types.replace(/\s/g, '').split(',') : null;
        if (!$scope.buttonLabel) {
            var key = !types || types.length > 1 ? 'all' : types[0];
            $scope.buttonLabel = mediaTypeOptions[key].buttonLabel;
        }
        if (!types) {
            // no 'types' specified
            mediaTypeOption = mediaTypeOptions.all;
            types = ['image', 'video', 'audio', 'document'];
        } else if (types.length > 1) {
            // to pick more than 1 asset type
            for (var i = 0; i < types.length; i++) {
                if (mediaTypeOptions.all.assetTypes.indexOf(types[i]) === -1) {
                    throw new Error(types + ' contains invalid media picker type(s).');
                }
            }
            mediaTypeOption = extendDeep({}, mediaTypeOptions.all, { assetTypes: types.concat(['folder']) });
        } else {
            // only 1 asset type
            if (mediaTypeOptions.all.assetTypes.indexOf(types[0]) === -1) {
                throw new Error('[' + types[0] + '] is not a valid media picker type.');
            }
            mediaTypeOption = mediaTypeOptions[types[0]];
        }
        $scope.selectOrChange = function () {
            return $scope.selectedAsset ? 'Change' : 'Select';
        };
        $scope.openResourcePicker = function openResourcePicker() {
            var picker = new ResourcePicker(extendDeep({}, defaultOptions, mediaTypeOption, {
                selectedAsset: $scope.selectedAsset,
                types: types,
                params: {
                    where: {
                        folder_id: 0,
                        type: { in: mediaTypeOption.assetTypes }
                    }
                },
                resolve: {
                    assetTypes: function assetTypes() {
                        return mediaTypeOption.assetTypes;
                    }
                },
                toolbar: [{
                                    name: 'new-folder',
                                    buttonClass: 'btn btn-primary',
                                    template: '<i class="material-icon material-icon-create-folder"></i> Create folder',
                                    act: function act(selected, options, params) {
                
                                        var folderId = 0;
                
                                        if (params && params.where) {
                                            folderId = params.where.folder_id || 0;
                                        }
                
                                        $uibModal.open({
                                            controller: 'MediaEditCtrl',
                                            templateUrl: 'ng-komondor-media-library/media.edit.html',
                                            resolve: {
                                                model: ['Asset', function (Asset) {
                                                    return Asset.createInstance({
                                                        folder_id: folderId
                                                    });
                                                }],
                                                folderId: [function () {
                                                    return folderId;
                                                }],
                                                actions: ['Action', function (Action) {
                                                    return Action.findAll();
                                                }],
                                                files: [function () {
                                                    return null;
                                                }],
                                                assetTypes: [function () {
                                                    return ['folder', 'image', 'video', 'audio', 'document'];
                                                }]
                                            }
                                        });
                                    },
                                    show: function show() {
                                        return kdGate.allows('media.create');
                                    }
                                }, {
                                    name: 'upload',
                                    buttonClass: 'btn btn-primary',
                                    template: '<i class="material-icon material-icon-upload"></i> Upload',
                                    act: function act(selected, options, params) {
                                        $uibModal.open({
                                            windowClass: 'media-upload-modal',
                                            controller: 'MediaUpload',
                                            controllerAs: '$ctrl',
                                            templateUrl: 'ng-komondor-media-library/media-upload.html',
                                            resolve: {
                                                folderId: [function () {
                                                    if (!params || !params.where || !params.where.folder_id) {
                                                        return 0;
                                                    }
                                                    return params.where.folder_id;
                                                }]
                                            }
                                        });
                                    },
                                    show: function show() {
                                        return kdGate.allows('media.create');
                                    }
                                }]
            }));
            picker.result.then(function (data) {
                $scope.selectedAssets(data);
            });
        };
        $scope.$on('open-media-picker', function () {
            $scope.openResourcePicker();
        });
        $rootScope.$broadcast('media-picker-loaded');
    }
    function link($scope, element, attrs, ngModel) {
        $scope.$watch(function () {
            return ngModel.$viewValue;
        }, function (assetId) {
            assetCache.get(assetId).then(function (asset) {
                $scope.selectedAsset = asset;
            });
        });
        $scope.preview = function () {
            $uibModal.open({
                windowClass: 'modal-media-preview',
                templateUrl: 'ng-komondor-media-library/media.preview.html',
                controller: ["$scope", "model", "File", function controller($scope, model, File) {
                    $scope.hideFooter = true;
                    $scope.model = model;
                    File.bindAll({ asset_id: model.id }, $scope, 'files');
                }],
                resolve: {
                    model: ["Asset", function model(Asset) {
                        return Asset.findAll({
                            with: 'breadcrumbs',
                            where: { id: { '==': $scope.selectedAsset.id } }
                        }).then(function (data) {
                            return data[0];
                        });
                    }],
                    files: ["File", function files(File) {
                        var params = { asset_id: $scope.selectedAsset.id };
                        File.ejectAll(params);
                        return File.findAll(params);
                    }]
                }
            });
        };
        $scope.selectedAssets = function (models) {
            ngModel.$setViewValue(models[0].id);
        };
        $scope.clear = function () {
            $scope.selectedAsset = null;
            ngModel.$setViewValue(null);
        };
    }
}]);
'use strict';
angular.module('ngKomondorMediaLibrary').config(["styleGuideProvider", function (styleGuideProvider) {
    styleGuideProvider.push({
        label: 'Media Library',
        templateUrl: 'ng-komondor-media-library/guide.uploader.html',
        controller: function controller($scope, Uploader) {
            $scope.uploader = new Uploader();
            $scope.existing = [{
                            filename: 'Existing File',
                            size: 62142233
                        }];
            $scope.uploading = [{
                            progress: 0,
                            file: {
                                name: 'Queued File',
                                size: 12352340
                            }
                        }, {
                            progress: 35,
                            file: {
                                name: 'Partially Uploaded File',
                                size: 6234665
                            }
                        }, {
                            progress: 100,
                            file: {
                                name: 'Uploaded File',
                                size: 77233445443
                            }
                        }];
        }
    });
}]);
'use strict';
angular.module('ngKomondorTargetedImagery').factory('AreaObject', function () {
    return function (paper, areaData) {
        var self = this;
        var ghost = null;
        var path = new paper.Path();
        path.areaObject = this;
        this.fixed = true;
        this.corners = {
            tl: null,
            tr: null,
            br: null,
            bl: null
        };
        this.areaData = areaData;
        for (var corner in this.corners) {
            if (this.corners.hasOwnProperty(corner)) {
                var point = new paper.Point(this.areaData.data[corner].x, this.areaData.data[corner].y);
                this.corners[corner] = path.add(point).point;
                this.corners[corner].corner = corner;
            }
        }
        path.closed = true;
        path.fullySelected = false;
        path.fillColor = getFillColor(this.areaData.opacity);
        path.attach('doubleclick', function () {
            self.setFixed(!self.fixed);
        });
        this.removeGhost = function () {
            if (ghost) {
                ghost.remove();
            }
            ghost = null;
        };
        this.makeGhost = function () {
            this.removeGhost();
            if (Number(this.areaData.rotate)) {
                ghost = path.clone();
                ghost.fullySelected = false;
                ghost.fillColor = new paper.Color(0.5, 0.5, 0.5, 0.3);
                ghost.strokeColor = new paper.Color(0.5, 0.5, 0.5, 0.3);
                ghost.insertBelow(path);
                ghost.rotate(Number(this.areaData.rotate));
            }
        };
        this.makeGhost();
        this.setFixed = function (fixedValue) {
            self.fixed = fixedValue;
            if (self.fixed) {
                path.fillColor = getFillColor(this.areaData.opacity);
            } else {
                path.fillColor = new paper.Color(0.2, 0.8, 0.2, 0.3);
            }
        };
        this.select = function () {
            path.fullySelected = true;
        };
        this.unselect = function () {
            this.setFixed(true);
            path.fullySelected = false;
        };
        this.remove = function () {
            path.remove();
            this.removeGhost();
        };
        this.onClick = function (f) {
            path.attach('click', function () {
                f(self);
            });
        };
        this.movePoint = function (corner, deltaX, deltaY) {
            var moveIt = function moveIt(corner, deltaX, deltaY) {
                self.corners[corner].x += deltaX;
                self.corners[corner].y += deltaY;
                self.areaData.data[corner].x = self.corners[corner].x;
                self.areaData.data[corner].y = self.corners[corner].y;
            };
            moveIt(corner, deltaX, deltaY);
            if (this.fixed) {
                if (corner === 'tl') {
                    moveIt('tr', 0, deltaY);
                    moveIt('bl', deltaX, 0);
                }
                if (corner === 'tr') {
                    moveIt('tl', 0, deltaY);
                    moveIt('br', deltaX, 0);
                }
                if (corner === 'bl') {
                    moveIt('br', 0, deltaY);
                    moveIt('tl', deltaX, 0);
                }
                if (corner === 'br') {
                    moveIt('bl', 0, deltaY);
                    moveIt('tr', deltaX, 0);
                }
            }
            this.makeGhost();
        };
        this.movePath = function (deltaX, deltaY) {
            path.position.x += deltaX;
            path.position.y += deltaY;
            for (var corner in this.corners) {
                if (this.corners.hasOwnProperty(corner)) {
                    this.areaData.data[corner].x = this.corners[corner].x;
                    this.areaData.data[corner].y = this.corners[corner].y;
                }
            }
            this.makeGhost();
        };
        this.cloneData = function () {
            var areaData = angular.copy(this.areaData);
            for (var corner in areaData.data) {
                if (areaData.data.hasOwnProperty(corner)) {
                    areaData.data[corner].x += 20;
                    areaData.data[corner].y += 20;
                }
            }
            return areaData;
        };
        this.setOpacity = function () {
            path.fillColor = getFillColor(self.areaData.opacity);
        };
        function getFillColor(opacity) {
            return new paper.Color(0, 0.75, 1, opacity);
        }
    };
});
'use strict';
angular.module('ngKomondorTargetedImagery').directive('areaSelector', ["$window", "$timeout", "AreaObject", "targetedImageryConfig", "File", function ($window, $timeout, AreaObject, targetedImageryConfig, File) {
    return {
        restrict: 'A',
        templateUrl: 'ng-komondor-media-library/area.selector.html',
        scope: { areas: '=' },
        link: function link($scope, element, attrs) {
            var paper = $window.paper;
            var gridLines = [];
            var areaObjects = [];
            $scope.grid = {
                enabled: false,
                size: 40
            };
            $scope.types = targetedImageryConfig.types || { logo: 'Client Logo' };
            $scope.areas = $scope.areas || [];
            $scope.config = targetedImageryConfig;
            $scope.move = { size: 1 };
            element.addClass('area-selector');
            var canvasEl = element.find('canvas');
            var canvas = canvasEl[0];
            var raster;
            $scope.$watchGroup(['areas', function () {
                            return attrs.background;
                        }], function () {
                init();
            });
            $scope.toggleGrid = function () {
                if ($scope.grid.enabled) {
                    gridLines = drawGridLines($scope.grid.size, $scope.grid.size, canvas.width, canvas.height);
                } else {
                    for (var i = 0; i < gridLines.length; i++) {
                        gridLines[i].remove();
                    }
                    gridLines = [];
                }
                paper.view.draw();
            };
            function init() {
                $scope.selectedAreaObject = null;
                var file = File.get(attrs.background);
                if (!file || !file.links.download) {
                    return;
                }
                var src = File.get(attrs.background).links.download;
                paper.setup(canvas);
                raster = new paper.Raster({ source: src });
                raster.onLoad = function () {
                    canvas.width = raster.width;
                    canvas.height = raster.height;
                    raster.position.x = raster.width / 2;
                    raster.position.y = raster.height / 2;
                    var rect = new paper.Path.Rectangle({
                        point: [0, 0],
                        size: [raster.width, raster.height],
                        selected: false
                    });
                    rect.sendToBack();
                    rect.fillColor = 'white';
                    if ($scope.areas) {
                        for (var i = 0; i < $scope.areas.length; i++) {
                            $scope.addArea($scope.areas[i]);
                        }
                    }
                    $timeout(function () {
                        canvasEl.css('width', 'auto');
                    });
                };
            }
            var setSelected = function setSelected(areaObject) {
                if ($scope.selectedAreaObject === areaObject) {
                    return;
                }
                if ($scope.selectedAreaObject) {
                    $scope.selectedAreaObject.unselect();
                }
                areaObject.areaData.type = areaObject.areaData.type || 'logo';
                $scope.selectedAreaObject = areaObject;
                $scope.selectedAreaObject.select();
            };
            function backwardsCompatibility(areaData) {
                if (!angular.isNumber(areaData.blur)) {
                    areaData.blur = areaData.blur ? 5 : 0;
                }
                if (angular.isUndefined(areaData.opacity)) {
                    areaData.opacity = 1;
                }
            }
            $scope.addArea = function (areaData) {
                if (areaData === undefined) {
                    //Default area
                    areaData = {
                        behind: false,
                        blur: 0,
                        multiply: false,
                        type: 'logo',
                        opacity: 1,
                        rotate: 0,
                        data: {
                            tl: {
                                x: 30,
                                y: 25
                            },
                            // tl corner
                            tr: {
                                x: 75,
                                y: 25
                            },
                            // tr
                            bl: {
                                x: 30,
                                y: 80
                            },
                            // bl
                            br: {
                                x: 75,
                                y: 80    // br
                            }
                        }
                    };
                    $scope.areas.push(areaData);
                } else {
                    backwardsCompatibility(areaData);
                }
                var newArea = new AreaObject(paper, areaData);
                newArea.onClick(function (object) {
                    setSelected(object);
                    $scope.$apply();
                });
                areaObjects.push(newArea);
                paper.view.draw();
                return newArea;
            };
            $scope.removeArea = function () {
                var objectIndex = areaObjects.indexOf($scope.selectedAreaObject);
                areaObjects.splice(objectIndex, 1);
                $scope.selectedAreaObject.remove();
                var index = $scope.areas.indexOf($scope.selectedAreaObject.areaData);
                $scope.areas.splice(index, 1);
                $scope.selectedAreaObject = null;
                paper.view.draw();
            };
            $scope.cloneArea = function () {
                var newAreaData = $scope.selectedAreaObject.cloneData();
                $scope.areas.push(newAreaData);
                setSelected(this.addArea(newAreaData));
            };
            $scope.moveArea = function (direction) {
                if (direction === 'up') {
                    $scope.selectedAreaObject.movePath(0, $scope.move.size * -1);
                }
                if (direction === 'down') {
                    $scope.selectedAreaObject.movePath(0, $scope.move.size);
                }
                if (direction === 'left') {
                    $scope.selectedAreaObject.movePath($scope.move.size * -1, 0);
                }
                if (direction === 'right') {
                    $scope.selectedAreaObject.movePath($scope.move.size, 0);
                }
                paper.view.draw();
            };
            $scope.opacityArea = function () {
                $scope.selectedAreaObject.setOpacity();
                paper.view.draw();
            };
            $scope.rotateArea = function () {
                $scope.selectedAreaObject.makeGhost();
                paper.view.draw();
            };
            function drawGridLines(numRectanglesWide, numRectanglesTall, width, height) {
                var lines = [];
                var i, aLine;
                var widthPerRectangle = width / numRectanglesWide;
                var heightPerRectangle = height / numRectanglesTall;
                for (i = 0; i <= numRectanglesWide; i++) {
                    var xPos = i * widthPerRectangle;
                    var topPoint = new paper.Point(xPos, 0);
                    var bottomPoint = new paper.Point(xPos, height);
                    aLine = new paper.Path.Line(topPoint, bottomPoint);
                    aLine.strokeColor = '#DADADA';
                    aLine.insertAbove(raster);
                    lines.push(aLine);
                }
                for (i = 0; i <= numRectanglesTall; i++) {
                    var yPos = i * heightPerRectangle;
                    var leftPoint = new paper.Point(0, yPos);
                    var rightPoint = new paper.Point(width, yPos);
                    aLine = new paper.Path.Line(leftPoint, rightPoint);
                    aLine.strokeColor = '#DADADA';
                    aLine.insertAbove(raster);
                    lines.push(aLine);
                }
                return lines;
            }
            function enableDrag() {
                var hitOptions = {
                    segments: true,
                    stroke: true,
                    fill: true,
                    tolerance: 10
                };
                var segment, path;
                var tool = new paper.Tool();
                tool.onMouseDown = function (event) {
                    segment = path = null;
                    var hitResult = paper.project.hitTest(event.point, hitOptions);
                    if (!hitResult) {
                        return;
                    }
                    if (hitResult.type === 'segment') {
                        segment = hitResult.segment;
                        path = hitResult.item;
                    }
                    if (hitResult.type === 'fill') {
                        path = hitResult.item;
                    }
                };
                tool.onMouseDrag = function (event) {
                    if (segment) {
                        segment.path.areaObject.movePoint(segment.point.corner, event.delta.x, event.delta.y);
                    } else if (path) {
                        path.areaObject.movePath(event.delta.x, event.delta.y);
                    }
                };
            }
            enableDrag();
        }
    };
}]);
'use strict';
angular.module('ngKomondorTargetedImagery').controller('MediaTargetedImageryCtrl', ["$rootScope", "$scope", "$stateParams", "model", "$state", "$http", "DS", "notify", "kdMedia", "targetedImageryConfig", "files", function ($rootScope, $scope, $stateParams, model, $state, $http, DS, notify, kdMedia, targetedImageryConfig, files) {
    var defaultAreaSet = {
        background: files.length > 0 ? files[0].id : null,
        shapes: []
    };
    var init = function init() {
        $scope.config = targetedImageryConfig;
        $scope.model = model;
        $scope.kdMedia = kdMedia;
        $scope.error = null;
        if ($scope.model.isSvg()) {
            $scope.error = 'Svg cannot be a targeted image!';
        } else {
            $scope.error = null;
        }
        $scope.selectedAreaSet = setSelectedAreaSet(files);
        $scope.backgroundId = null;
        $scope.model.areas = $scope.model.areas || [angular.copy(defaultAreaSet)];
        if ($scope.model.areas.length > 0) {
            $scope.selectAreaSet($scope.model.areas[0]);
        } else {
            $scope.addAreaSet();
        }
    };
    $scope.copyAreas = function () {
        return $http.post('/api/targeted-imagery/copy', { areas: $scope.model.areas }).then(function () {
            notify.confirm('Areas copied!');
        });
    };
    $scope.pasteAreas = function () {
        $http.post('/api/targeted-imagery/paste', { asset_id: $scope.model.id }).then(function (response) {
            $scope.model.areas = response.data.areas;
            $scope.selectAreaSet($scope.model.areas[0]);
            $rootScope.$broadcast('targeted-imagery:saved', $scope.model);
            notify.alert('Image areas have been pasted.');
        });
    };
    $scope.addAreaSet = function () {
        var n = angular.copy(defaultAreaSet);
        $scope.model.areas.push(n);
        $scope.selectAreaSet(n);
    };
    $scope.copyAreaSet = function () {
        var n = angular.copy($scope.selectedAreaSet);
        $scope.model.areas.push(n);
        $scope.selectAreaSet(n);
    };
    $scope.removeAreaSet = function () {
        var index = $scope.model.areas.indexOf($scope.selectedAreaSet);
        $scope.model.areas.splice(index, 1);
        if ($scope.model.areas[0] !== undefined) {
            $scope.selectAreaSet($scope.model.areas[0]);
        } else {
            $scope.selectedAreaSet = null;
        }
    };
    $scope.backgroundChange = function () {
        $scope.selectedAreaSet.background = $scope.backgroundId;
    };
    $scope.selectAreaSet = function (areaSet) {
        $scope.selectedAreaSet = areaSet;
        $scope.backgroundId = $scope.selectedAreaSet.background;
    };
    $scope.goBack = function () {
        $state.go('admin.media');
    };
    $scope.save = function () {
        var areasIndex = $scope.model.areas.indexOf($scope.selectedAreaSet);
        model.DSSave().then(function () {
            $scope.selectAreaSet($scope.model.areas[areasIndex]);
            $rootScope.$broadcast('targeted-imagery:saved', model);
            notify.alert('Image areas have been saved.');
        });
    };
    function setSelectedAreaSet(files) {
        var selectedFile = files.reduce(function (selected, file) {
            if (file.filename.indexOf('optimized') > -1) {
                selected = file;
            }
            return selected;
        }, null);
        return selectedFile ? selectedFile : files[0];
    }
    init();
}]);
'use strict';
angular.module('ngKomondorTargetedImagery').factory('targetedImageryAction', ["$state", "targetedImageryConfig", function ($state, targetedImageryConfig) {
    return {
        buttonClass: 'btn btn-default',
        template: '<span>Targeted image</span>',
        act: function act(models) {
            $state.go('.targeted-imagery', { id: models[0].id });
        },
        show: function show(models) {
            if (!targetedImageryConfig.allowEdit) {
                return false;
            }
            return models.length === 1 && models[0].type === 'image' && models[0].targeted;
        }
    };
}]);
'use strict';
angular.module('ngKomondorTargetedImagery').config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('admin.media.targeted-imagery', {
        url: '/targeted-imagery/{id:[0-9w-]+}',
        resolve: {
            model: ['Asset', '$stateParams', function (Model, $stateParams) {
                            return Model.find($stateParams.id).then(function (data) {
                                return data;
                            });
                        }],
            files: ['File', '$stateParams', function (File, $stateParams) {
                            return File.findAll({
                                where: {
                                    asset_id: $stateParams.id,
                                    mime_type: {
                                        in: ['image/jpeg', 'image/png']
                                    }
                                }
                            }, { bypassCache: true });
                        }]
        },
        views: {
            'header@': { template: '' },
            '@admin': {
                controller: 'MediaTargetedImageryCtrl',
                templateUrl: 'ng-komondor-media-library/media.targeted.imagery.html'
            }
        }
    });
}]);
'use strict';
angular.module('ng-komondor-media-library.templates', []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("ng-komondor-media-library/area.selector.html", "<div class=\"controls\" ng-if=\"config.allowEdit\"><ul class=\"targeted-imagery-menu\"><li><a class=\"glyphicon glyphicon-plus\" ng-click=\"addArea()\">Add</a></li><li><a class=\"glyphicon glyphicon-remove\" ng-click=\"removeArea()\" ng-show=\"selectedAreaObject !== null\">Remove</a></li><li><a class=\"glyphicon glyphicon-copy\" ng-click=\"cloneArea()\" ng-show=\"selectedAreaObject !== null\">Clone</a></li></ul><ul ng-show=\"selectedAreaObject !== null\" class=\"targeted-imagery-menu\"><li><label for=\"behind-checkbox\">Behind <input id=\"behind-checkbox\" type=\"checkbox\" ng-model=\"selectedAreaObject.areaData.behind\"></label></li><li><label for=\"multiply-checkbox\">Multiply <input id=\"multiply-checkbox\" type=\"checkbox\" ng-model=\"selectedAreaObject.areaData.multiply\"></label></li><li><label for=\"blur-input\">Blur</label><input id=\"blur-input\" min=\"0\" max=\"10\" type=\"number\" ng-model=\"selectedAreaObject.areaData.blur\"></li><li><label for=\"opacity-input\">Opacity</label><input id=\"opacity-input\" ng-change=\"opacityArea()\" min=\"0.1\" step=\"0.1\" max=\"1\" type=\"number\" ng-model=\"selectedAreaObject.areaData.opacity\"></li><li><label for=\"rotate-input\">Rotate</label><input id=\"rotate-input\" ng-change=\"rotateArea()\" type=\"number\" ng-model=\"selectedAreaObject.areaData.rotate\"></li><li><label for=\"type-select\">Type</label><select id=\"type-select\" ng-model=\"selectedAreaObject.areaData.type\" ng-options=\"key as value for (key , value) in types\"></select></li></ul><ul class=\"targeted-imagery-menu pull-right\" ng-show=\"selectedAreaObject !== null\"><li class=\"grid-tool\"><label for=\"grid-checkbox\">Grid <input id=\"grid-checkbox\" ng-click=\"toggleGrid()\" ng-model=\"grid.enabled\" type=\"checkbox\"></label><input id=\"grid-size\" type=\"number\" ng-model=\"grid.size\"></li><li class=\"move-tool\"><label for=\"move-selected-size\">Move</label><input type=\"number\" id=\"move-selected-size\" ng-model=\"move.size\"><a class=\"glyphicon glyphicon-chevron-up\" ng-click=\"moveArea(\'up\')\"></a><a class=\"glyphicon glyphicon-chevron-down\" ng-click=\"moveArea(\'down\')\"></a><a class=\"glyphicon glyphicon-chevron-left\" ng-click=\"moveArea(\'left\')\"></a><a class=\"glyphicon glyphicon-chevron-right\" ng-click=\"moveArea(\'right\')\"></a></li></ul></div><div class=\"canvas\"><canvas keepalive=\"true\" hidpi=\"off\" data-paper-keepalive=\"true\"></canvas></div>");
  $templateCache.put("ng-komondor-media-library/file.existing.html", "<p class=\"file-upload-info\" ng-if=\"!item.file\"><span>{{ item.filename }}</span><span class=\"file-upload-size\">{{ item.size | bytes }}</span></p><div class=\"file-upload-toolbar row clearfix\"><div class=\"file-upload-progress col-xs-8\"></div><div class=\"file-upload-actions col-xs-4 clearfix\"><div class=\"btn-group pull-right\" role=\"group\"><a class=\"btn btn-primary btn-xs\" title=\"Download\" target=\"_blank\" ng-attr-download=\"{{ item.filename }}\" ng-href=\"{{ item.links.download }}\"><i class=\"glyphicon glyphicon-download\"></i></a><button type=\"button\" class=\"btn btn-danger btn-xs pull-right\" title=\"Remove\" ng-click=\"onRemove(item)\"><i class=\"glyphicon glyphicon-trash\"></i></button></div></div></div>");
  $templateCache.put("ng-komondor-media-library/file.uploader.html", "<div class=\"media-file-selector\" nv-file-drop nv-file-over uploader=\"$ctrl.uploader\"><label class=\"panel panel-primary text-center media-file-drop\" for=\"media_upload_file\" role=\"button\"><div class=\"panel-body\"><p class=\"h2\">Drag and drop files</p><p class=\"h4\">Image, video, audio and documents</p><p><u>Browse files</u></p></div></label><input type=\"file\" id=\"media_upload_file\" nv-file-select uploader=\"$ctrl.uploader\" multiple><div ng-if=\"isExceeded()\">File upload count exceeded: You’ve attempted to upload {{getTotalItems()}} files at a single time, the current limit is {{queueLimit}}. The first {{queueLimit}} files will be uploaded and all other files we need to be loaded in a separate batch.</div></div><ul class=\"file-upload-list list-unstyled\"><li ng-repeat=\"item in $ctrl.uploader.queue\" file-uploading=\"item\"></li></ul>");
  $templateCache.put("ng-komondor-media-library/file.uploading.html", "<div class=\"file-uploading\" ng-class=\"{error: item.isError, success: item.isSuccess, cancel: item.isCancel}\"><p class=\"file-upload-info\" ng-if=\"item.file\"><span>{{ item.file.name }}</span><span class=\"file-upload-size\" ng-show=\"item.uploader.isHTML5\">{{ item.file.size | bytes }}</span></p><div class=\"file-padded\"><div ng-hide=\"item.isUploaded\"><span ng-show=\"item.progress === 0\">0%</span><uib-progressbar value=\"item.progress\" ng-show=\"item.progress\"><span>{{ item.progress }}%</span></uib-progressbar></div><div class=\"row\" ng-show=\"item.isUploaded\"><div class=\"col-xs-8\"><div ng-show=\"item.isError\" class=\"text-danger\"><span ng-if=\"item._xhr.status !== 400\">Upload failed: {{ getResponse() }}</span><span ng-if=\"item._xhr.status === 400\">{{ item._xhr.response }}</span></div></div><div class=\"col-xs-4 text-right\"><div ng-show=\"item.isSuccess\"><span class=\"material-icon material-icon-done text-success\"></span></div><div ng-show=\"item.isError\"><i class=\"material-icon material-icon-error text-danger\"></i></div></div></div></div></div>");
  $templateCache.put("ng-komondor-media-library/guide.uploader.html", "<div class=\"row\"><div class=\"col-xs-6\"><h1>File selector</h1><div ng-include=\"\'ng-komondor-media-library/file.selector.html\'\"></div><hr><h1>File selector with drag over</h1><div ng-include=\"\'ng-komondor-media-library/file.selector.html\'\" class=\"nv-file-over\"></div><hr></div><div class=\"col-xs-6\"><h3>Existing and uploading files</h3><ul class=\"file-upload-list list-unstyled\"><li ng-repeat=\"item in existing\" file-existing=\"item\" on-remove=\"remove\"></li><li ng-repeat=\"item in uploading\" file-uploading=\"item\"></li></ul></div></div>");
  $templateCache.put("ng-komondor-media-library/media-upload.html", "<form ng-submit=\"$ctrl.close()\"><div class=\"modal-header text-center\"><button type=\"submit\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">Upload media</h1></div><div class=\"modal-body\"><div file-uploader=\"$ctrl.uploader\"></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-disabled=\"!$ctrl.uploader.queue.length || $ctrl.uploader.isUploading\" ng-click=\"$ctrl.clear()\">Clear</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"$ctrl.uploader.isUploading\">Done</button></div></div></div></form>");
  $templateCache.put("ng-komondor-media-library/media.display.html", "<img ng-src=\"{{ model.links.download }}\" ng-if=\"model.type == \'image\'\"><video autoplay controls ng-if=\"model.type == \'video\'\"><source ng-src=\"{{ model.links[\'mp4\'] }}\" type=\"video/mp4 \" ng-if=\"model.links[\'mp4\']\"><source ng-src=\"{{ model.links[\'webm\'] }}\" type=\"video/webm\" ng-if=\"model.links[\'webm\']\"><source ng-src=\"{{ model.links[\'ogg\'] }}\" type=\"video/webm\" ng-if=\"model.links[\'ogg\']\">Your browser does not support the video tag.</video><audio controls ng-if=\"model.type == \'audio\'\"><source ng-src=\"{{ model.links[\'mp3\'] }}\" type=\"audio/mpeg\" ng-if=\"model.links[\'mp3\']\"><source ng-src=\"{{ model.links[\'ogg\'] }}\" type=\"audio/ogg\" ng-if=\"model.links[\'ogg\']\"><source ng-src=\"{{ model.links[\'wav\'] }}\" type=\"audio/wav\" ng-if=\"model.links[\'wav\']\">Your browser does not support the audio tag.</audio>");
  $templateCache.put("ng-komondor-media-library/media.edit.html", "<form ng-submit=\"save()\" class=\"media-upload\"><div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ ::model.id ? \'Edit\' : \'New\' ;}} {{ ::model.type }}</h1></div><div class=\"modal-body\"><div form-group=\"name\"><label for=\"title-field\">Name</label><input id=\"title-field\" class=\"form-control\" type=\"text\" ng-model=\"model.name\"></div><div form-group=\"checkboxes\" class=\"row\" ng-if=\"targetedImageryConfig.allowEdit && model.type === \'image\' && !model.isSvg()\"><checkbox-input name=\"targeted\" label=\"\'Targeted image\'\" ng-model=\"model.targeted\" true-value=\"1\" false-value=\"0\"></checkbox-input></div><div form-group=\"file\" ng-if=\"!model.id\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"create()\">Add Files</button></div><div ng-if=\"model.id\" file-uploader=\"uploader\"></div><div form-group=\"file-upload-list\"><ul class=\"file-upload-list list-unstyled\"><li ng-repeat=\"item in files\" file-existing=\"item\" on-remove=\"remove(item)\"></li></ul></div><div ng-if=\"::kdMedia.enableVideoPoster\"><div form-group=\"poster_second\" ng-if=\"model.type === \'video\'\"><label for=\"poster_second\">Preview image</label><div class=\"input-group\"><input type=\"number\" min=\"0\" max=\"{{primaryFile.meta.duration}}\" id=\"poster_second\" class=\"form-control\" ng-model=\"model.config.poster.time\" placeholder=\"Create preview at...\"><span class=\"input-group-addon\" id=\"basic-addon2\">Runtime: {{primaryFile.meta.duration}}s</span></div></div></div><tags-edit ng-if=\"mediaLibraryTaggingConfig.allowEdit\" model=\"model\"></tags-edit></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"cancel()\">Cancel</button></div><div class=\"col-xs-6\"><button type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"uploader.isUploading\" loading-disabled>Save</button></div></div></div></form>");
  $templateCache.put("ng-komondor-media-library/media.preview.html", "<div class=\"modal-header text-center\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h1 class=\"modal-title\">{{ model.name }}</h1></div><div class=\"modal-body\"><div media-display asset-id=\"model.id\"></div><div class=\"asset-breadcrumbs\" ng-if=\"::model.breadcrumbs.length\"><a class=\"asset-breadcrumbs-link btn-block\" ui-sref=\"admin.media({folder_id: model.folder_id})\" target=\"_blank\"><span ng-repeat=\"breadcrumb in model.breadcrumbs\">{{ breadcrumb.label }}<span class=\"asset-breadcrumbs-divider\">></span></span>{{ ::model.name }}</a><div class=\"inactive-asset-breadcrumbs ng-hide\"><span ng-repeat=\"breadcrumb in model.breadcrumbs\">{{ breadcrumb.label }}<span class=\"asset-breadcrumbs-divider\">></span></span>{{ ::model.name }}</div></div><div class=\"file-list\"><label>Files</label><table class=\"table table-striped\"><tr ng-repeat=\"file in files\"><td>{{ file.filename }}</td><td><a class=\"material-icon material-icon-file-download pull-right\" target=\"_blank\" ng-href=\"{{ file.links.download }}\"></a></td></tr></table></div></div><div class=\"modal-footer\" ng-if=\"!hideFooter\"><div class=\"row\"><div class=\"col-xs-4\"><a type=\"button\" ng-if=\"model.editable\" class=\"btn btn-primary btn-block\" ui-sref=\"admin.media.edit({id: model.id})\">Edit</a></div><div class=\"col-xs-4\"><a type=\"button\" ng-if=\"model.editable\" class=\"btn btn-danger btn-block\" ui-sref=\"admin.media.delete({ids: model.id})\">Delete</a></div><div class=\"col-xs-4\"><a type=\"button\" class=\"btn btn-default btn-block\" ng-click=\"$dismiss()\">Close</a></div></div></div>");
  $templateCache.put("ng-komondor-media-library/media.targeted.imagery.html", "<div class=\"targeted-imagery\"><div ng-if=\"error\" class=\"alert alert-danger\" role=\"alert\"><a ui-sref=\"admin.media({folder_id: model.folder_id})\">&#8592; Go back &nbsp;</a>{{error}}</div><div ng-if=\"!error\"><div class=\"targeted-imagery-header\"><h3>{{model.name}}<a href=\"javascript:void(0)\" ng-click=\"pasteAreas()\" class=\"glyphicon glyphicon-paste pull-right ml-2\"><span class=\"ml-1\">Paste</span></a><a href=\"javascript:void(0)\" ng-click=\"copyAreas()\" ng-if=\"model.areas && model.areas.length\" class=\"glyphicon glyphicon-copy pull-right\"><span class=\"ml-1\">Copy</span></a></h3></div><div class=\"targeted-imagery-area-sets\"><ul class=\"targeted-imagery-menu\"><li ng-repeat=\"set in model.areas\"><a ng-click=\"selectAreaSet(set)\" ng-class=\"{\'glyphicon-folder-open\' : selectedAreaSet === set}\" class=\"glyphicon glyphicon-folder-close area-set-select\"><span>Version {{model.areas.indexOf(set) + 1}}</span></a></li><li ng-if=\"config.allowEdit\"><a ng-show=\"selectedAreaSet !== null && model.areas.length > 1\" class=\"area-set-remove glyphicon glyphicon-remove\" ng-click=\"removeAreaSet()\"><span>Delete</span></a></li><li ng-if=\"config.allowEdit\"><a ng-show=\"selectedAreaSet !== null && model.areas.length > 0\" class=\"area-set-remove glyphicon glyphicon-copy\" ng-click=\"copyAreaSet()\"><span>Clone</span></a></li><li ng-if=\"config.allowEdit && selectedAreaSet.background\"><a ng-click=\"addAreaSet()\" class=\"glyphicon glyphicon-plus area-set-add\"><span>Add new</span></a></li></ul></div><div ng-show=\"selectedAreaSet !== null && model.areas.length > 0\" area-selector areas=\"selectedAreaSet.shapes\" background=\"{{selectedAreaSet.background}}\"></div><div class=\"targeted-imagery-footer\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"goBack()\">Cancel</button><button ng-if=\"config.allowEdit\" type=\"button\" class=\"btn btn-primary\" ng-click=\"save()\">Save</button></div><div class=\"clearfix\"></div></div></div></div>");
}]);
})();

//# sourceMappingURL=ng-komondor-media-library.js.map
